import {ChangeDetectionStrategy, Component, computed, input} from "@angular/core";
import {
  Fumigant,
  FumigantApplication,
  Fumigation
} from "@portbase/bezoekschip-service-typescriptmodels";
import {PortvisitUtils} from "../../../../../refdata/portvisit-utils";

@Component({
  selector: 'app-fumigation-details',
  templateUrl: './fumigation-details.component.html',
  styleUrls: ['./fumigation-details.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FumigationDetailsComponent {

  portvisitUtils = PortvisitUtils;

  fumigation = input<Fumigation>();

  fumigantOptions = new Set<string>([
    Fumigant.PHOSPHINE,
    Fumigant.ALUMINIUM_PHOSPHIDE,
    Fumigant.MAGNESIUM_PHOSPHIDE
  ]);

  showConditionalFields = computed(() =>
    this.fumigantOptions.has(this.fumigation().fumigant)
  );

  showSleevesUsedRemoved = computed(() =>
    this.showConditionalFields() && FumigantApplication.SLEEVES === this.fumigation().fumigantApplication
  );
}
